export enum ActivityStatus {
  'IN_PROGRESS' = 'IN_PROGRESS',
  'COMPLETED' = 'COMPLETED',
  'ON_HOLD' = 'ON_HOLD',
  'CANCELED' = 'CANCELED',
}
